var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button"},[_c('v-btn',_vm._b({style:(_vm.styles),on:{"click":function($event){return _vm.$emit('click-btn')}}},'v-btn',_vm.$props,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }